module.exports = __webpack_public_path__ + "img/bullet-check-s.1b89d46a.svg";